module.exports = __webpack_public_path__ + "img/ko.bed9e8de.png";